// @flow
import React from 'react'
import styled from 'styled-components'
import media from '../../../../styles/media'

type ButtonProps = {
  href: string,
  icon: string,
  style: Object
}

const Component = styled.div`
  display: flex;

  ${media.mdUp} {
    justify-content: flex-end;
  }
`

const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  height: 25px;
  font-size: 13px;
  color: #fff;
  padding: 5px 8px;
  margin-left: 5px;
  border-radius: 3px;

  &:hover,
  &:focus {
    text-decoration: none;
    color: #fff;
    opacity: 0.9;
  }
`

const SocialButton = ({ icon, href, style }: ButtonProps) => (
  <Button href={href} target="_blank" rel="noopener noreferrer" style={style}>
    <span className={`fa fa-${icon}`} />
  </Button>
)

const SocialButtons = () => {
  if (typeof window === 'undefined') return null

  const href = window.location.href

  return (
    <Component>
      <SocialButton
        icon="facebook"
        style={{ background: '#3b5998' }}
        href={`https://www.facebook.com/sharer/sharer.php?u=${href}`}
      />
      <SocialButton
        icon="twitter"
        style={{ background: '#00aced' }}
        href={`https://twitter.com/home?status=${href}`}
      />
      <SocialButton
        icon="pinterest"
        style={{ background: '#c92228' }}
        href={`https://pinterest.com/pin/create/button/?url=${href}`}
      />
    </Component>
  )
}

export default SocialButtons



// WEBPACK FOOTER //
// ./src/views/Property/components/SocialButtons/index.js